import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { AppRoutes } from '../AppRoutes';

const PermissionsMyPage = lazy(() =>
  import('@/pages/permission-my').then((module) => ({
    default: module.PermissionsMyPage,
  }))
);

export const permissionRouter: RouteObject[] = [
  {
    path: AppRoutes.PERMISSIONS_MY,
    element: <PermissionsMyPage />,
  },
];
